import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Inject} from "inversify-props";
import {CreditService} from "@/app/services/credit.service";
import {INDIE_CONSTANTS} from "@/app/shared/common/constants";

@Component<CreditBookDifferent>({
    components: ({})
})
export default class CreditBookDifferent extends Vue {
    @Inject() public creditService: CreditService;
    @Prop({default: null}) orderId: number;

    @Watch("dismissCountDown", {deep: true, immediate: true})
    onDismissCountDownUpdated(newVal: number, oldVal: number){
        if(newVal === 0){
            this.$bvModal.hide('credit-information-fares');
            this.$store.dispatch("storeCreditUrlParam", null);
            this.$store.dispatch("storeCreditData", null);
            this.$cookies.set(INDIE_CONSTANTS.CREDIT_STRING_COOKIE_KEY, null);
            this.$router.push('/');
        }
    }

    private message: string = '';

    private show = false;

    private showConfirmationMessage = false;
    private dismissCountDown = 5;

    private toggle(){
        this.show = !this.show;
        this.$emit('toggle', this.show);
    }

    private submitMessage(){
        this.creditService.sendRebookDifferentMessageRequest(this.message, this.orderId).then(res => {
            this.showConfirmationMessage = true;
        });
    }

    private countDownChanged(dismissCountDown: number){
        this.dismissCountDown = dismissCountDown
    }
}
